// @flow
import {createStandardAction} from 'typesafe-actions'

export const setTouchCapability = createStandardAction('INTERACTION_CAPABILITIES/TOUCH/SET')<boolean>()
export const setHovercapability = createStandardAction('INTERACTION_CAPABILITIES/HOVER/SET')<boolean>()
